import { useRef } from 'react';
import { ERROR_BEEP_BASE64, SCAN_BEEP_BASE64, SUCCESS_BEEP_BASE64 } from '../utils/soundBase64';

const useSoundPlayer = () => {
    const playing = useRef<Record<string, boolean>>({});

    const play = (key: string, src: string, volume = 1) => {
        if (playing.current[key]) return;

        playing.current[key] = true;
        const audio = new Audio(src);
        audio.volume = volume;
        audio.onended = () => {
            playing.current[key] = false;
        };
        audio.play();
    };

    return {
        playScan: () => play('scan', SCAN_BEEP_BASE64, 1),
        playSuccess: () => play('success', SUCCESS_BEEP_BASE64, 1),
        playError: () => play('error', ERROR_BEEP_BASE64, 0.4),
    };
};

export default useSoundPlayer;
